module.exports = __webpack_public_path__ + "assets/2a3652de81354e8620592d81a83b9a69.png";